import React from 'react';
import AdminDashboardLayout from '../../../layouts/AdminDashboardLayout';
import { useI18n } from '@whizz/react-i18n';
import { Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import Button from '../../../components/button/Button';
import { MaterialIcon } from '../../../components';
import { ADMIN_ROUTES, QUERIES_IDS, ROUTES } from '../../../util/vars';
import { useQuery } from 'react-query';
import { repository } from '@whizz/api-client';
import { WeeklyLeadersEmailsPageComponent } from '../WeeklyLeadersEmails/WeeklyLeadersEmailsPageComponent';
import { ImpactReportPageComponent } from '../ImpactReports/ImpactReportsPageComponent';
import { TabsNav } from '../../../components/tabs/Tabs';
import { AdminImplementationPlan } from './modules/AdminImplementationPlan';

export type { SchoolGoal } from '@whizz/api-model';

const ImplementationPageComponent = (): JSX.Element | null => {
  const history = useHistory();
  const { url } = useRouteMatch();
  const { translate: t } = useI18n();
  const { schoolId } = useParams<{ schoolId: string }>();

  const backToSchools = () => history.push(`${ROUTES.superAdmin}${ADMIN_ROUTES.schools}`);

  const getWeeklyLeadersEmails = useQuery({
    queryKey: [ QUERIES_IDS.ADMIN.GET_WEEKLY_LEADERS_EMAILS, schoolId ],
    queryFn: () => repository.AdminRepository.getSchoolWeeklyLeadersEmail(Number(schoolId)),
  });

  const weeklyLeadersEmail = getWeeklyLeadersEmails.data?.data ?? null;

  if (!weeklyLeadersEmail) {
    return null;
  }

  return (
    <AdminDashboardLayout
      title={t('pages.ADMIN.HEADER')}
      action={
        <Button
          type={'button'}
          isOutline
          onClick={() => backToSchools()}
        >
          <MaterialIcon
            icon={'ChevronLeft'}
          />
          {t('pages.ADMIN.SCHOOLS.CHANGE')}
        </Button>}
    >
      <div className={'flex gap-5'}>
        <div className={'flex flex-col gap-5 w-1/4 p-md rounded-lg bg-white shadow'}>
          <h2 className={'text-2xl font-bold'}>Implementation Plan</h2>
          <span className={'text-xl font-bold'}>
            {weeklyLeadersEmail.school.name}, {weeklyLeadersEmail.school.postcode}, ID: {weeklyLeadersEmail.school.id}
          </span>
          <hr className={'h-px my-4 bg-gray-300 border-0'} />
          <AdminImplementationPlan />
        </div>
        <div className={'flex flex-col gap-5 w-3/4'}>
          <TabsNav
            id={'implementationTabs'}
            tabs={[
              {
                to: `${url}${ADMIN_ROUTES.implementation.weeklyLeadersEmails}`,
                label: t('pages.ADMIN.LEADERS_EMAILS.TITLE'),
              },
              {
                to: `${url}${ADMIN_ROUTES.implementation.impactReports}`,
                label: t('pages.ADMIN.IMPACT_REPORTS.TITLE'),
              },
            ]}
          />
          <ImplemetationRoutes />
        </div>
      </div>
    </AdminDashboardLayout>
  );
};

const ImplemetationRoutes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}${ADMIN_ROUTES.implementation.impactReports}/:jobId?`}>
        <ImpactReportPageComponent />
      </Route>
      <Route path={`${path}${ADMIN_ROUTES.implementation.weeklyLeadersEmails}`}>
        <WeeklyLeadersEmailsPageComponent />
      </Route>
    </Switch>
  );
};

export { ImplementationPageComponent };
